import { render, staticRenderFns } from "./IconifyIcon.vue?vue&type=template&id=373f18c9"
import script from "./IconifyIcon.vue?vue&type=script&lang=js"
export * from "./IconifyIcon.vue?vue&type=script&lang=js"
import style0 from "./IconifyIcon.vue?vue&type=style&index=0&id=373f18c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports